import React, { useEffect } from 'react';
import { useForm } from '../../hooks/useForm';
import { Flex } from '../../common/Containers';
import { CustomButton } from '../../common';
import moment from 'moment';
import { FilterModal, FilterPropTypes } from '../../components/Filters/FilterModal';
import { DateInput } from '../../components/Inputs';
import { SchoolSelect } from '../../components/Inputs/SchoolSelect';

interface BigFilterPropTypes extends FilterPropTypes {
  onSave: (value: any) => void;
}

export const InvoiceFilter: React.FC<BigFilterPropTypes> = ({ open, handleClose, onSave }) => {
  const { values, forceChange } = useForm<{
    from: number;
    to: number;
    schoolId: string;
  }>({
    from: moment().startOf('year').unix(),
    to: moment().startOf('second').unix(),
    schoolId: null,
  });
  return (
    <FilterModal open={open} handleClose={handleClose}>
      <Flex column>
        <Flex>
          <DateInput
            value={moment.unix(values.from)}
            onChange={(e: any) => {
              forceChange(moment(e).unix(), 'from');
            }}
            name="from"
            id="from"
            info="From"
          />
          <DateInput
            value={moment.unix(values.to)}
            onChange={(e: any) => {
              forceChange(moment(e).unix(), 'to');
            }}
            name="to"
            id="to"
            info="To"
          />
        </Flex>
        <Flex>
          <SchoolSelect
            value={values.schoolId}
            onChange={(e: any, obj: any) => forceChange(obj.id, 'schoolId')}
          />
        </Flex>
        <Flex>
          <CustomButton
            content="confirm"
            width="100%"
            height="56px"
            onClick={() => onSave(values)}
          />
        </Flex>
      </Flex>
    </FilterModal>
  );
};
